<ng-container
  *ngTemplateOutlet="
    isCustomPlpRoute && (isCustomPlpEnabled$ | async) ? customPlp : isCategoryPlpRoute ? categoryPlp : catalog
  "
></ng-container>

<ng-template #customPlp>
  <app-custom-plp [commonProps]="commonProps"></app-custom-plp>
</ng-template>

<ng-template #categoryPlp>
  <app-category-plp [commonProps]="commonProps"></app-category-plp>
</ng-template>

<ng-template #catalog>
  <app-catalog [commonProps]="commonProps"></app-catalog>
</ng-template>
